import * as React from "react";


import {ReactUtilities} from "../../../utilities/react/ReactUtilities";
import {SpinnerButton} from "../../SpinnerButton";


import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";


    export class Footer extends React.Component<FooterProps, FooterState> {
        static defaultProps: Partial<FooterProps> = {
            CancelButtonText:'Cancel',
            CancelButtonIcon:<FontAwesomeIcon icon={faTimes}/>,
            ApplyButtonText:'Apply',
            ApplyButtonIcon:<FontAwesomeIcon icon={faCheck}/>,
            IsBusy:false
        };

        constructor(props: FooterProps, context?: any) {
            super(props, context);
            this.state = {};
        }

        public render() {
            return (
                <div className={'rnFooter'} style={{display:'flex',justifyContent:'flex-end'}}>
                    {this.GetFooterArea()}
                </div>
            )
        }

        public GetFooterArea(){
            if(this.props.FooterArea==null)
            return(
                <React.Fragment>
                {this.props.EnableCancel
                &&<button style={{display:'flex',alignItems:'center'}} onClick={()=>ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnCancel)}
                          className={'rnbtn rnbtn-danger'}>{this.props.CancelButtonIcon} {<span style={{marginLeft:this.props.CancelButtonIcon!=null?5:0}}>{this.props.CancelButtonText}</span>}</button>}
                    {this.props.EnableApply &&
                    <SpinnerButton IsBusy={this.props.IsBusy} Icon={this.props.ApplyButtonIcon}
                                   OnClick={() => ReactUtilities.ExecuteMethodPropIfDefined(this.props.OnApply)}
                                   className={'rnbtn rnbtn-success'}>{this.props.ApplyButtonText}</SpinnerButton>
                    }
                </React.Fragment>
            );

            return this.props.FooterArea;
        }
    }



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FooterProps {
    CancelButtonText?:string;
    CancelButtonIcon?:any;
    EnableCancel:boolean;
    EnableApply?:boolean;
    FooterArea:JSX.Element

    IsBusy:boolean;
    ApplyButtonText?:string;
    ApplyButtonIcon?:any;
    OnApply?:()=>any;
    OnCancel?:()=>any;
}

interface FooterState {

}


//#endregion "My Region"